import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ee63ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "item__header" }, " IS_BUSY: ", -1))
const _hoisted_2 = { class: "item__value" }

import { computed, toRefs } from 'vue'
import { BasicModelDetailsList } from '@components/basic'
import PlaceDetailsHeader from '@/components/places/PlaceDetailsHeader.vue'
import ArticlesListModal from '@/components/article/ArticlesListModal.vue'
import { TPlace } from '@/const/types/place'
import useModals from '@/composable/useModals'

interface Props {
  item: TPlace;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaceDetailsView',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: TPlace;
};



const { item: place } = toRefs(props)

const articles = computed(
    () => place.value.aggregatedPlacements
        .map(placement => placement.combination ? ({ ...placement.combination, quantity: placement.quantity, name: `${placement.combination.product.name} | ${placement.combination.name}` }) : ({ quantity: placement.quantity, ...placement.product})
    )
)
const hasArticles = computed(() => Boolean(place.value.aggregatedPlacements && place.value.aggregatedPlacements.length > 0))

const MODALS = {
    ARTICLES: 'articles',
} as const;

const {
    isModalOpen,
    closeModal,
    openModal,
} = useModals({ types: MODALS });


return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PlaceDetailsHeader, {
      "has-articles": _unref(hasArticles),
      onOpenArticles: _cache[0] || (_cache[0] = ($event: any) => (_unref(openModal)(_unref(MODALS).ARTICLES)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(place).name), 1)
      ]),
      _: 1
    }, 8, ["has-articles"]),
    _createVNode(_unref(BasicModelDetailsList), {
      model: _unref(place),
      "model-name": "Place"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_label, { class: "item__inner" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(place).is_busy ? 'true' : 'false'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (_unref(hasArticles))
      ? (_openBlock(), _createBlock(ArticlesListModal, {
          key: 0,
          articles: _unref(articles),
          "is-open": _unref(isModalOpen)(_unref(MODALS).ARTICLES),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(closeModal)(_unref(MODALS).ARTICLES)))
        }, null, 8, ["articles", "is-open"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})